export default __webpack_public_path__ + "static/media/arrow-right-light.f1135cae.svg";